import type { InputProps as AntdInputProps, InputRef } from 'antd'
import { Input as AntdInput } from 'antd'
import { forwardRef } from 'react'

import styles from './styles.module.scss'

export interface InputProps extends AntdInputProps {
  showSuffixOnlyOnHover?: boolean
}

export const Input = forwardRef<InputRef, InputProps>(
  ({ className, showSuffixOnlyOnHover, disabled, ...props }, ref) => {
    const classNames = [
      className,
      styles.inputContainer,
      disabled ? styles.disabled : '',
      showSuffixOnlyOnHover ? styles.hideSuffixOnHover : '',
    ].join(' ')

    return <AntdInput ref={ref} {...props} className={classNames} disabled={disabled} />
  },
)
Input.displayName = 'Input'
